<form [formGroup]="priceForm" (ngSubmit)="submitPrice()">
    <label for="packet">Preis Paket</label><br />
    <input type="string" name="packet" id="packet" formControlName="packet" />
    <label for="single">Preis Single</label><br />
    <input type="string" name="single" id="single" formControlName="single" />
    <button class="button" type="submit"><span>Speichern</span></button>
  </form>
  